export class Customerdeal {
    dealId:string;
    dealname:string;
    dealdetail:string;
    dealcrmId?:string;
    dealdate:string;
    dealowner:string;
    customerId:string;
    customercrmId?:string;
    dealstatus:string;
    creator:string;
    versioncreator:string;
    created:string;
    validfrom:string;
    validto:string;
    organizationId:string;
    projectCount:number;
}